import { createFilterTracker, NEWS_FILTER_SCHEMA } from './filterAnalytics';

export default function initNewsListing() {
	const root = document.querySelector('[data-news-list]');
	if (!root) {
		return;
	}

	const filterTracker = createFilterTracker('news', NEWS_FILTER_SCHEMA);

	const bar = document.querySelector('[data-newsfilterbar]');
	const qInput = bar?.querySelector('[data-news-q]');
	const labelSel = bar?.querySelector('[data-news-label]');
	const submitQ = bar?.querySelector('[button][data-submit="q"]') || bar?.querySelector('[data-submit="q"]');
	const clearQ = bar?.querySelector('[data-clear="q"]');
	const moreBtn = document.querySelector('[data-news-more]');

	const initialType = (root.getAttribute('data-news-type') || moreBtn?.getAttribute('data-news-type') || '').trim();
	const initialCategory = (root.getAttribute('data-news-category') || moreBtn?.getAttribute('data-news-category') || '').trim();

	const state = {
		q: (qInput?.value || '').trim(),
		label: (labelSel?.value || '').trim(),
		type: initialType,
		category: initialCategory,
		page: Math.max(1, parseInt(root.getAttribute('data-page') || '1', 10)),
		perPage: Math.max(1, parseInt(root.getAttribute('data-per-page') || '12', 10)),
		maxPages: Math.max(1, parseInt(root.getAttribute('data-max-pages') || '1', 10)),
		loading: false
	};

	// Baseline the initial news filter state (seeded from inputs / URL) so it is
	// not reported as a fresh apply on the first applyFilters() call.
	filterTracker.init({ q: state.q, label: state.label, type: state.type, category: state.category });

	function updateMoreVisibility() {
		const hasMore = state.page < state.maxPages;
		if (moreBtn && !hasMore) {
			moreBtn.classList.add('hidden');
		}
	}

	function buildURL(page = 1) {
		const u = new URL('/wp-json/olt/v1/news', window.location.origin);
		u.searchParams.set('per_page', state.perPage);
		u.searchParams.set('page', page);
		if (state.q) {
			u.searchParams.set('q', state.q);
		}
		if (state.label) {
			u.searchParams.set('label', state.label);
		}
		if (state.type) {
			u.searchParams.set('type', state.type);
		}
		if (state.category) {
			u.searchParams.set('category', state.category);
		}
		u.searchParams.set('match', 'OR');
		return u.toString();
	}

	async function fetchPage(page = 1, append = true) {
		if (state.loading) {
			return;
		}
		state.loading = true;
		root.setAttribute('data-loading', '1');
		try {
			const res = await fetch(buildURL(page), { credentials: 'same-origin' });
			if (!res.ok) {
				throw new Error('Failed to load news');
			}
			const json = await res.json();

			if (!append) {
				root.innerHTML = '';
			}
			root.insertAdjacentHTML('beforeend', json.itemsHtml || '');

			state.page = page;
			state.maxPages = json.max_pages || 1;
			root.setAttribute('data-page', String(state.page));
			root.setAttribute('data-max-pages', String(state.maxPages));
		} catch (e) {
			console.error(e);
		} finally {
			state.loading = false;
			root.removeAttribute('data-loading');
			updateMoreVisibility();
		}
	}

	function applyFilters() {
		state.q = (qInput?.value || '').trim();
		state.label = (labelSel?.value || '').trim();
		filterTracker.track({ q: state.q, label: state.label, type: state.type, category: state.category });
		state.page = 1;
		fetchPage(1, false);
		const url = new URL(window.location.href);
		state.q ? url.searchParams.set('q', state.q) : url.searchParams.delete('q');
		state.label ? url.searchParams.set('label', state.label) : url.searchParams.delete('label');
		state.type ? url.searchParams.set('type', state.type) : url.searchParams.delete('type');
		state.category ? url.searchParams.set('category', state.category) : url.searchParams.delete('category');
		window.history.replaceState({}, '', url.toString());
	}

	submitQ?.addEventListener('click', (e) => {
		e.preventDefault();
		applyFilters();
	});

	clearQ?.addEventListener('click', (e) => {
		e.preventDefault();
		if (qInput) {
			qInput.value = '';
		}
		applyFilters();
	});

	qInput?.addEventListener('keydown', (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			applyFilters();
		}
	});

	labelSel?.addEventListener('change', () => {
		applyFilters();
	});

	moreBtn?.addEventListener('click', () => {
		if (state.page < state.maxPages) {
			fetchPage(state.page + 1, true);
		}
	});

	updateMoreVisibility();
}
